import styled from "styled-components"
import media from "../../styles/breakPoints"

import IconClose from "../../images/icon-close.svg"

const BoxModal = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(57,47,45,0.8);
  pointer-events: auto;
  opacity: 0;
  visibility: hidden;
  -webkit-overflow-scrolling: touch;
  z-index: 80;
  transition: all 0.4s linear;
  &.-visible {
     opacity: 1;
     visibility: visible;
     transition: all 0.4s linear;
  }
`

const BoxContent = styled.div`
  width: 90vw;
  height: 80vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  z-index: 85;
  background-color: ${props => props.theme.color.secondyLight2};
  overflow-y: auto;
  overflow-x: hidden;


  ${media.greaterThan("sm")`
      width: 80vw;
  `}

  ${media.greaterThan("lg")`
      width: 90vw;
      max-width: 900px;
      max-height: 600px;
      overflow: hidden;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 1rem;
  `}

  ${media.greaterThan("xl")`
      max-width: 1100px;
   `}

`

const ColumnContent = styled.div`
   display: block;
   width: 100%;
   height: auto;
   padding: 15px;

   ${media.greaterThan("lg")`
      overflow-x: auto;
      overflow-y: visible;
      padding: 15px 20px;
      &::-webkit-scrollbar {
         -webkit-appearance: none;
         width: 7px;
      }
      &::-webkit-scrollbar-thumb {
         border-radius: 4px;
         background-color: ${props => props.theme.color.secondyDark1};
         box-shadow: 0 0 1px rgba(255,255,255,.5);
      }
   `}

   ${media.greaterThan("xl")`
      padding: 25px;
   `}

`

const CloseButton = styled.button`
   position: absolute;
   top: 0;
   right: 0;
   background-color: transparent;
   z-index: 90;
   padding: 15px;
   margin: 5px 10px;
   border: none;
   cursor: pointer;
   background-image: url(${IconClose});
   background-position: center;
   background-repeat: no-repeat;
   background-size: contain;
   text-indent: -9999px;
   &:focus {
      outline: 0;
   }

`

const Title = styled.h3`
   font-family: ${props => props.theme.font.primary};
   font-size: ${props => props.theme.size.mediumSmall};
   font-weight: 600;
   line-height: 3rem;
   color: ${props => props.theme.color.thirdBase};
   text-transform: uppercase;
   margin-bottom: 2rem;
`

const Description = styled.div`
   margin-bottom: 20px;
`

const Line = styled.p`
   font-family: ${props => props.theme.font.secondy};
   font-size: ${props => props.theme.size.small};
   font-weight: 400;
   line-height: 3rem;
   color: ${props => props.theme.color.grayDark};
   margin: 0;
`

export {
   BoxModal,
   BoxContent,
   ColumnContent,
   CloseButton,
   Title,
   Description,
   Line
}